export const genericOptionFormatter = (code:any, name:any, value:any) => {
  return {value: value, label:`${code} - ${name}`}
}